import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { hMacAjax as fetch } from 'grt-tool-lib-front';
import { url } from '@/api/organization';
import { getMessage } from './util';
let { improveOrgList } = url;
// data_source_type 1自定义  2平台数据源
const SelectForm = (props) => {
    let { setting = {}, updated, desc, field_type } = props;

    const disabled = updated !== 0,
        [options, setOptions] = useState([]);

    //请求后端数据源接口
    let getOptions = () => {
        // setTimeout(() => {
        //     setOptions([{ id: 1, name: '平台数据源' }]);
        // }, 500);

        fetch.get(improveOrgList).then((res) => {
            if (res.success) {
                let items = [];
                for (let i = 0; i < res.data?.length; i++) {
                    let item = {
                        id: res.data[i]['id'],
                        name: res.data[i]['org_name']
                    };
                    items.push(item);
                }
                setOptions(items);
            }
        });
    };
    useEffect(() => {
        if (setting.data_source_type === 1) {
            let enabledOption = setting.options.filter((ele) => ele.enabled === true);

            setOptions(enabledOption);
        } else {
            getOptions();
        }
    }, []);

    return (
        <Select
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            mode={setting.type === 'multiple' ? 'multiple' : ''}
            disabled={disabled}
            fieldNames={{ label: 'name', value: 'id' }}
            placeholder={desc || getMessage(field_type)}
            options={options}
            showSearch={false}
            listHeight={135}
            className={'grt-dynamic-select'}
            allowClear
        />
    );
};
export default SelectForm;
